module.exports = __webpack_public_path__ + "officialStatic/img/begx.3d5f95a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/begx.jpg
// module id = zNP5
// module chunks = 0